import classNames from "classnames";
import React from "react";
import Dot from "./Dot";
import moment from "moment";

interface Props {
  dotColor: string
  small?: boolean
  linkTo?: string
}

const DotLabel = (props: React.PropsWithChildren<Props>) => {
  const { dotColor, small, linkTo } = props;

  const labelClasses = classNames({
    s1_small: small
  });

  return <span className="dotLabel">
    <span>
      <Dot color={dotColor} small={small} />
    </span>
    {linkTo
      ? (
        <a href={linkTo} className={labelClasses}>
          {props.children}
        </a>
      )
      : (
        <span className={labelClasses}>
          {props.children}
        </span>
      )}
  </span>;
};

export const RelativeTimeToNowDotLabel = ({ dateTime }: { dateTime: moment.Moment }) => {
  if (dateTime.isAfter(moment.utc())) {
    return <DotLabel dotColor={serverReference.constants.colors.green}>{dateTime.fromNow()}</DotLabel>;
  }

  return <DotLabel dotColor={serverReference.constants.colors.red}>{dateTime.fromNow()}</DotLabel>;
}

export const VisibilityDotLabel = ({ visible }: { visible: boolean }) => {
  if (visible) {
    return <DotLabel dotColor={serverReference.constants.colors.green}>{RESX.GeneralLabels.Visible}</DotLabel>
  }

  return <DotLabel dotColor={serverReference.constants.colors.red}>{RESX.GeneralLabels.NotVisible}</DotLabel>
}

export default DotLabel;